var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelopeNoDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4634 12.5212H2.53679C2.18163 12.5208 1.84113 12.3795 1.59001 12.1284C1.33888 11.8772 1.19764 11.5367 1.19727 11.1816V4.4334C1.19764 4.07824 1.33888 3.73773 1.59001 3.48658C1.84113 3.23543 2.18163 3.09416 2.53679 3.09375H13.4634C13.8185 3.09416 14.159 3.23543 14.4102 3.48658C14.6613 3.73773 14.8025 4.07824 14.8029 4.4334V11.1816C14.8025 11.5367 14.6613 11.8772 14.4102 12.1284C14.159 12.3795 13.8185 12.5208 13.4634 12.5212V12.5212ZM2.53679 3.60575C2.31736 3.60599 2.107 3.69327 1.95186 3.84843C1.79672 4.0036 1.70947 4.21398 1.70927 4.4334V11.1816C1.70947 11.401 1.79672 11.6114 1.95186 11.7665C2.107 11.9217 2.31736 12.009 2.53679 12.0092H13.4634C13.6828 12.009 13.8932 11.9217 14.0483 11.7665C14.2034 11.6114 14.2907 11.401 14.2909 11.1816V4.4334C14.2907 4.21398 14.2034 4.0036 14.0483 3.84843C13.8932 3.69327 13.6828 3.60599 13.4634 3.60575H2.53679Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99923 9.31407C7.93682 9.3141 7.87656 9.29134 7.82975 9.25007L1.66016 3.80392L1.99897 3.41992L7.99923 8.71707L13.9997 3.42056L14.3386 3.80456L8.16895 9.25071C8.12203 9.29187 8.06165 9.31441 7.99923 9.31407V9.31407Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.52148 11.7168L5.66615 6.99439L6.05118 7.33231L1.90651 12.0547L1.52148 11.7168Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96094 7.32715L10.346 6.98923L14.4907 11.7117L14.1057 12.0497L9.96094 7.32715Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeNoDot);
export default __webpack_public_path__ + "static/media/envelope-no-dot.fc922fea45e9b9ec9d2dc9971696e934.svg";
export { ForwardRef as ReactComponent };